<i
  class="fa fa-lg fa-info-circle"
  style="color: #515365"
  [ngbTooltip]="info"
  tooltipClass="info-tooltip"
></i>
